var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.className},_vm._l((_vm.data.children),function(component,i){return _c(component.typeHandle,{key:`block-content-children-${i}`,tag:"component",attrs:{"data":component}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }